<svg 
      [attr.width]="size" 
      [attr.height]="size" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      [attr.stroke-width]="strokeWidth" 
      stroke-linecap="round" 
      stroke-linejoin="round" 
      [class]="class"
    >
      <ng-container [ngSwitch]="name">
        <path *ngSwitchCase="'chevron-right'" d="m9 18 6-6-6-6"/>
        <path *ngSwitchCase="'chevron-left'" d="m15 18-6-6 6-6"/>
        <path *ngSwitchCase="'x'" d="M18 6 6 18M6 6l12 12"/>
        <circle *ngSwitchCase="'search'" cx="11" cy="11" r="8"/><path *ngSwitchCase="'search'" d="m21 21-4.3-4.3"/>
        <path *ngSwitchCase="'building-2'" d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/><path *ngSwitchCase="'building-2'" d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/><path *ngSwitchCase="'building-2'" d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/><path *ngSwitchCase="'building-2'" d="M10 6h4"/><path *ngSwitchCase="'building-2'" d="M10 10h4"/><path *ngSwitchCase="'building-2'" d="M10 14h4"/><path *ngSwitchCase="'building-2'" d="M10 18h4"/>
        <path *ngSwitchCase="'map-pin'" d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle *ngSwitchCase="'map-pin'" cx="12" cy="10" r="3"/>
        <circle *ngSwitchCase="'globe'" cx="12" cy="12" r="10"/><path *ngSwitchCase="'globe'" d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20"/><path *ngSwitchCase="'globe'" d="M2 12h20"/>
        <path *ngSwitchCase="'arrow-left'" d="m12 19-7-7 7-7"/><path *ngSwitchCase="'arrow-left'" d="M19 12H5"/>
      </ng-container>
    </svg>